module.exports = __webpack_public_path__ + "static/media/1.667ffc88.jpg";